import React, { useRef } from 'react';
import { TeklifBilgisi } from '../types';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface TeklifOnizlemeProps {
  teklifBilgisi: TeklifBilgisi;
}

const TeklifOnizleme: React.FC<TeklifOnizlemeProps> = ({ teklifBilgisi }) => {
  const pdfRef = useRef<HTMLDivElement>(null);

  // KDV hesaplama - %20
  const kdvTutar = teklifBilgisi.toplamTutar * 0.2;
  const kdvliToplam = teklifBilgisi.toplamTutar + kdvTutar;

  const handlePDFIndir = () => {
    const input = pdfRef.current;
    if (!input) return;

    const scale = 2; // Daha yüksek kalite için ölçeklendirme
    const options = {
      scale: scale,
      useCORS: true,
      logging: false,
      allowTaint: true
    };

    html2canvas(input, options).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      
      // A4 boyutu: 210mm x 297mm
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      
      // Tam sayfa
      pdf.addImage(
        imgData, 
        'PNG', 
        0, // x pozisyonu (sol kenar)
        0, // y pozisyonu (üst kenar)
        pdfWidth, // genişlik - tam sayfa
        imgHeight * ratio // yükseklik - orantılı
      );
      
      pdf.save('teklif.pdf');
    });
  };

  return (
    <div>
      <h2>Teklif Önizleme</h2>
      
      {/* PDF Önizleme - A4 boyutunda (210mm x 297mm - 793px x 1123px) */}
      <div 
        className="pdf-container" 
        ref={pdfRef} 
        style={{ 
          width: '210mm', 
          minHeight: '297mm',
          margin: '0 auto',
          backgroundColor: 'white',
          padding: '0',
          boxSizing: 'border-box',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Mavi kavisli üst kısım */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '170px',
          background: 'linear-gradient(to right, #2c5a80, #7ba7cc, #ffffff)',
          borderBottomRightRadius: '50%',
          borderBottomLeftRadius: '50%',
          zIndex: '0'
        }}></div>
        
        {/* Logo ve iletişim bilgileri */}
        <div style={{
          padding: '20px',
          position: 'relative',
          zIndex: '1'
        }}>
          <div style={{
            backgroundColor: 'white',
            display: 'inline-block',
            padding: '15px',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <img src="/img/tusba-logo.png" alt="Tuşba Mobilya Logo" style={{ width: '120px' }} />
            <div style={{ textAlign: 'center', marginTop: '5px', fontWeight: 'bold' }}>0(545) 930 71 77</div>
          </div>
        </div>
        
        {/* Alıcı bilgileri */}
        <div style={{
          padding: '30px 20px',
          position: 'relative',
          zIndex: '1'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ color: '#2c5a80', marginRight: '10px', fontSize: '18px', width: '20px', textAlign: 'center' }}>⌂</span>
            <strong style={{ width: '80px' }}>Konum:</strong> 
            <span>{teklifBilgisi.alici}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ color: '#2c5a80', marginRight: '10px', fontSize: '18px', width: '20px', textAlign: 'center' }}>📅</span>
            <strong style={{ width: '80px' }}>Tarih:</strong> 
            <span>{teklifBilgisi.tarih}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ color: '#2c5a80', marginRight: '10px', fontSize: '18px', width: '20px', textAlign: 'center' }}>⏰</span>
            <strong style={{ width: '80px' }}>Saat:</strong> 
            <span>{teklifBilgisi.saat}</span>
          </div>
        </div>
        
        {/* Ürün tablosu */}
        <div style={{
          padding: '0 20px',
          position: 'relative',
          zIndex: '1'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '30px',
            border: '1px solid #ddd'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0' }}>
                <th style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd', width: '15%' }}>M²</th>
                <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', width: '45%' }}>AÇIKLAMA</th>
                <th style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd', width: '20%' }}>BİRİM FİYATI</th>
                <th style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd', width: '20%' }}>SATIŞ TOPLAMI</th>
              </tr>
            </thead>
            <tbody>
              {teklifBilgisi.urunler.map((urun) => (
                <tr key={urun.id}>
                  <td style={{ padding: '8px', textAlign: 'center', border: '1px solid #ddd' }}>{urun.metrekare}</td>
                  <td style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>{urun.aciklama}</td>
                  <td style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>{urun.birimFiyat.toLocaleString('tr-TR')}</td>
                  <td style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>{urun.satisToplam.toLocaleString('tr-TR')}</td>
                </tr>
              ))}
              {/* Toplam Satırı */}
              <tr style={{ backgroundColor: '#f9f9f9' }}>
                <td colSpan={3} style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd', fontWeight: 'bold' }}>Ara Toplam</td>
                <td style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd', fontWeight: 'bold' }}>{teklifBilgisi.toplamTutar.toLocaleString('tr-TR')} TL</td>
              </tr>
              
              {/* KDV Gösterimi - Checkbox işaretliyse göster */}
              {teklifBilgisi.kdvDahil && (
                <>
                  <tr>
                    <td colSpan={3} style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd' }}>KDV (%20)</td>
                    <td style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd' }}>{kdvTutar.toLocaleString('tr-TR')} TL</td>
                  </tr>
                  <tr style={{ backgroundColor: '#e9f0f7' }}>
                    <td colSpan={3} style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd', fontWeight: 'bold' }}>KDV Dahil Toplam</td>
                    <td style={{ padding: '10px', textAlign: 'right', border: '1px solid #ddd', fontWeight: 'bold', color: '#2c5a80' }}>{kdvliToplam.toLocaleString('tr-TR')} TL</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        
        {/* KDV bilgisi */}
        <div style={{
          padding: '20px',
          borderTop: '1px dashed #ddd',
          marginTop: '20px',
          fontStyle: 'italic',
          color: '#666',
          position: 'relative',
          zIndex: '1'
        }}>
          {teklifBilgisi.kdvDahil ? 'Fiyatlarımız %20 KDV dahildir.**' : 'Fiyatlarımız KDV hariçtir.**'}<br />
          Fiyatlarımız 7 gün geçerlidir.**
        </div>
      </div>
      
      {/* PDF İndir butonu */}
      <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '30px' }}>
        <button 
          onClick={handlePDFIndir}
          style={{
            backgroundColor: '#2c5a80',
            color: 'white',
            padding: '10px 25px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
          }}
        >
          PDF İndir
        </button>
      </div>
    </div>
  );
};

export default TeklifOnizleme;